var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnapperDimmed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Provider",
    transform: "translate(-360 -881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(360 881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Snapper-Logo-black"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sirkel",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M40,2.058A38.763,38.763,0,1,0,78.763,40.821,38.807,38.807,0,0,0,40,2.058m0,78.763A40.01,40.01,0,0,1,24.43,3.964,40.01,40.01,0,0,1,55.57,77.677,39.75,39.75,0,0,1,40,80.821",
    transform: "translate(0 -0.821)",
    fill: "#d2d4d6",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "snapper",
    transform: "translate(6.307 31.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M6.691,3.4a1.677,1.677,0,0,0-.777-.536,2.791,2.791,0,0,0-.928-.174,2.441,2.441,0,0,0-.528.06,2.03,2.03,0,0,0-.513.189,1.118,1.118,0,0,0-.392.339.86.86,0,0,0-.151.513.85.85,0,0,0,.362.739,3.422,3.422,0,0,0,.913.438q.551.181,1.184.362a4.891,4.891,0,0,1,1.185.513,2.809,2.809,0,0,1,.913.89,2.714,2.714,0,0,1,.362,1.494,3.436,3.436,0,0,1-.332,1.554,3.152,3.152,0,0,1-.9,1.1,3.815,3.815,0,0,1-1.313.649,5.771,5.771,0,0,1-1.577.211,5.723,5.723,0,0,1-1.931-.317A4.838,4.838,0,0,1,.61,10.4L2.285,8.561a2.442,2.442,0,0,0,.913.747,2.6,2.6,0,0,0,1.139.264A2.572,2.572,0,0,0,4.918,9.5a1.891,1.891,0,0,0,.528-.2,1.14,1.14,0,0,0,.377-.347.866.866,0,0,0,.143-.5.9.9,0,0,0-.37-.762,3.415,3.415,0,0,0-.928-.475q-.558-.2-1.207-.392A5.4,5.4,0,0,1,2.255,6.3a2.9,2.9,0,0,1-.928-.875,2.5,2.5,0,0,1-.37-1.433A3.21,3.21,0,0,1,1.3,2.48,3.276,3.276,0,0,1,2.2,1.393,3.937,3.937,0,0,1,3.507.737,5.344,5.344,0,0,1,5.031.518a5.994,5.994,0,0,1,1.75.257,4.042,4.042,0,0,1,1.524.86Z",
    transform: "translate(-0.61 -0.518)",
    fill: "#d2d4d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    d: "M88.624,3.128h3.2l4.542,7.424h.03V3.128h2.354V13.811H95.67L91.008,6.206h-.03v7.605H88.624Z",
    transform: "translate(-79.464 -2.856)",
    fill: "#d2d4d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    d: "M198.835,6.237l-1.3,3.32h2.61Zm-.905-3.108h1.947l4.648,10.683h-2.656l-.92-2.263H196.8l-.89,2.263h-2.6Z",
    transform: "translate(-173.311 -2.857)",
    fill: "#d2d4d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    d: "M310.8,7.655h1.569a3.025,3.025,0,0,0,.611-.06,1.624,1.624,0,0,0,.528-.2A1.089,1.089,0,0,0,313.881,7a1.242,1.242,0,0,0,.143-.626,1.06,1.06,0,0,0-.189-.656,1.256,1.256,0,0,0-.483-.385,2.069,2.069,0,0,0-.656-.174A6.784,6.784,0,0,0,312,5.12H310.8Zm-2.354-4.527h3.969a7.851,7.851,0,0,1,1.569.151,3.573,3.573,0,0,1,1.29.521,2.637,2.637,0,0,1,.875,1,3.414,3.414,0,0,1,.324,1.577,3.639,3.639,0,0,1-.3,1.569,2.575,2.575,0,0,1-.83,1.011,3.363,3.363,0,0,1-1.252.536,7.342,7.342,0,0,1-1.569.158H310.8v4.165h-2.354Z",
    transform: "translate(-276.486 -2.856)",
    fill: "#d2d4d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    d: "M399.245,7.655h1.569a3.025,3.025,0,0,0,.611-.06,1.623,1.623,0,0,0,.528-.2A1.089,1.089,0,0,0,402.33,7a1.242,1.242,0,0,0,.143-.626,1.059,1.059,0,0,0-.189-.656,1.255,1.255,0,0,0-.483-.385,2.07,2.07,0,0,0-.656-.174,6.788,6.788,0,0,0-.694-.038h-1.207Zm-2.354-4.527h3.969a7.853,7.853,0,0,1,1.569.151,3.573,3.573,0,0,1,1.29.521,2.637,2.637,0,0,1,.875,1,3.412,3.412,0,0,1,.324,1.577,3.639,3.639,0,0,1-.3,1.569,2.574,2.574,0,0,1-.83,1.011,3.363,3.363,0,0,1-1.252.536,7.34,7.34,0,0,1-1.569.158h-1.72v4.165h-2.354Z",
    transform: "translate(-355.754 -2.856)",
    fill: "#d2d4d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    d: "M486.208,3.128h7.258V5.3h-4.9V7.293h4.633V9.466h-4.633v2.173h5.176v2.173h-7.53Z",
    transform: "translate(-435.823 -2.856)",
    fill: "#d2d4d6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    d: "M576.141,7.55h1.388q.317,0,.672-.023a2.107,2.107,0,0,0,.641-.136,1.11,1.11,0,0,0,.475-.355,1.079,1.079,0,0,0,.189-.679,1.127,1.127,0,0,0-.166-.649,1.111,1.111,0,0,0-.422-.37,1.883,1.883,0,0,0-.589-.173,4.8,4.8,0,0,0-.649-.045h-1.539Zm-2.354-4.421h4.134a7.3,7.3,0,0,1,1.547.158,3.674,3.674,0,0,1,1.283.528,2.636,2.636,0,0,1,.875,1,3.375,3.375,0,0,1,.324,1.562,3.135,3.135,0,0,1-.588,1.924,2.649,2.649,0,0,1-1.72,1l2.716,4.512h-2.822L577.3,9.541h-1.162v4.27h-2.354Z",
    transform: "translate(-514.288 -2.857)",
    fill: "#d2d4d6",
    fillRule: "evenodd"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapperDimmed);
export default __webpack_public_path__ + "static/media/snapper_dimmed.b05721eb.svg";
export { ForwardRef as ReactComponent };